<template>
  <business-type-services />
</template>
<script>
import BusinessTypeServices from './components/BusinessTypeServices.vue';
export default {
  components: {
    BusinessTypeServices
  },
  data: function() {
    return {
      animation: {
        smTop: '-5px',
        smWidth: '110px',
        width: 240,
        height: 240,
        smHeight: 110,
        smWidth: 110
      },
      helpText: 'It helps us understand your business better'
    };
  }
}
</script>